import React from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { BsCart3 } from "react-icons/bs";
import NoElements from "../../../Components/NoElements";
import { useDispatch } from "react-redux";
import { uiActions } from "../../../store/ui";
import { useLocation } from "react-router-dom";
//nuevos imports
import { filterActions } from "../../../store/filter";
import { useSelector } from "react-redux";
import { useQueries } from "react-query";
import axios from "axios";
import loadingGift from '../../../../src/Assets/img/loadingGift.gif'
import loadingGiftt from '../../../../src/Assets/img/loadingGiftt.gif'
const ParkCard = ({ id, title, desc, image, disabled }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

        
  

  
  return (
    <div className="flex flex-col max-w-[30rem] border-2 p-px mx-4 my-4 text-center rounded-2xl tab-port:max-w-[25rem]">
      <Link to={`/detail/${id}`}>
        <img
          className="rounded-tr-xl rounded-tl-xl w-full items-center h-[20rem] tab-port:h-[17rem]"
          src={image}
          alt=""
        />
      </Link>
      <div className="px-14 py-12 border-t-2 tab-port:px-8">
        <h3 className="font-bold mb-4 text-2xl">{title}</h3>
        <p>{desc}</p>
      </div>
      {!disabled && (
        <div className="flex justify-center mb-4 mt-auto relative z-30">
          <button
            onClick={() => {
              dispatch(uiActions.wasFromPay({ conditional: true, parkId: id }));
              navigate(`/detail/payment/${id}`);
            }}
            className="w-11/12 px-4 py-3 text-xl font-bold bg-blue-600 rounded-md text-white outline-none hover:ring-4 focus:ring-4 shadow-lg transform active:scale-75 transition-transform"
          >
            <BsCart3 className="inline mr-4"></BsCart3>
            <span className="align-middle">Pagar ahora</span>
          </button>
        </div>
      )}
    </div>
  );
};

function ParkList({ parkList, mainTitle,imageFilter }) {
  const loadingGifttStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  };
  return (
    <div className="flex-col w-full tab-port:ml-10">
      <h1 className="text-[2.5em] my-10 text-center font-bold text-primary tab-port:text-left tab-port:ml-8 tab-port:font-medium">
        {mainTitle}
      </h1>
      <div className="flex flex-wrap justify-center w-full  mb-48 tab-port:flex-row tab-port:justify-start">
        {parkList < 1 ? (
          <NoElements />
        ) : (
          parkList.map((value) => {
            const isLoadingImage = !imageFilter || imageFilter.length === 0;
            const imageToShow = isLoadingImage
              ? loadingGiftt
              : imageFilter.find((image) => image.id === value.id)?.imagenPerfil || value.imagenPerfil;
    
            return (
              <ParkCard
                key={value.id}
                id={value.id}
                title={value.nombre}
               
                image={imageToShow} 
                desc={value.description.title}
                disabled={value.disabled}
                
              />
            );
          })
        )}
      </div>
    </div>
  );
}

export default ParkList;
